"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmationConfig = void 0;
class confirmationConfig {
}
exports.confirmationConfig = confirmationConfig;
// Mapping für intern verwendete Felder
confirmationConfig.fieldMapping = {
    // Hauptunterzeichner
    mainSigneeName: "dzvsignatoryv.name",
    // Vertreter
    deputyName: "dzvdeputyv.name",
    // Wer unterzeichnet (abgelehnt etc.) hat
    signedBySigneeName: "dzvsigneev.name",
};
// Zusätzliche Felder
confirmationConfig.documentFields = [];
// Sortierverhalten
confirmationConfig.documentSort = [
    {
        field: "ConfirmationObjects[0].SignAsDeputy",
        dir: "asc"
    }, {
        field: "ConfirmationObjects[0].Instance.items['cgdocument.lastchangedate'].value",
        dir: "asc"
    }
];
// Sortierverhalten History
confirmationConfig.historySort = [{
        field: "ConfirmationObjects[0].Instance.items['cgdocument.lastchangedate'].value",
        dir: "desc"
    }];
